(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fit-confidence-product"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = scope => {
    scope.querySelectorAll('.fc-product').forEach(root => {
      if (root.dataset.fcReady) return;
      root.dataset.fcReady = 'true';
      root.querySelectorAll('[data-fc-open]').forEach(link => {
        const dialog = document.getElementById(link.dataset.fcOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        link.setAttribute('aria-haspopup','dialog');
        link.addEventListener('click', event => {
          event.preventDefault();
          dialog._fitTrigger = link;
          dialog.showModal();
          dialog.querySelector('[data-fc-close]').focus({preventScroll:true});
          document.documentElement.classList.add('fc-modal-open');
          const body = dialog.querySelector('.fc-dialog-content');
          body.scrollTop = 0;
          const target = link.dataset.fcTarget && dialog.querySelector('[data-fc-part="'+link.dataset.fcTarget+'"]');
          if (target) { target.focus({preventScroll:true}); target.scrollIntoView({block:'start'}); }
        });
      });
      root.querySelectorAll('.fc-dialog').forEach(dialog => {
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex="0"]')].filter(el => el.getClientRects().length > 0);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
        dialog.querySelectorAll('[data-fc-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('fc-modal-open');
          dialog._fitTrigger?.focus({preventScroll:true});
        });
      });
      root.querySelectorAll('[data-fc-full-guide]').forEach(link => link.addEventListener('click', () => {
        try { sessionStorage.setItem('chisos-fit-return', window.location.href); } catch (error) {}
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
